import React, { useCallback } from 'react';
import { Exit, Container, Logo, Retangule, Menu, LI, Welcome, BoxRight } from './styles';
import LogoImage from '../../../assets/logomarca.png'
import { FiLogOut } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../../hooks/Auth';
import { useRoute } from '../../../hooks/Route';




const Preloader: React.FC = () => {



    const history = useHistory()
    const { signOut, credential } = useAuth()
    const { setRouteActive, routeActive } = useRoute();



    const handleGo = useCallback((rote: string) => {
        setRouteActive(rote)
        history.push(`/${rote}`)
    }, [history, setRouteActive])


    const handleGetOut = useCallback(() => {
        history.push('/')
        setRouteActive('')
        signOut()
    }, [history, signOut, setRouteActive])







    return (
        <Container>
            <Retangule>
                <a href="https://estudiocriar.com/" target="black">
                    <Logo src={LogoImage} />
                </a>
            </Retangule>

            <Menu>
                <ul>
                    <LI isActive={'register-user' === routeActive} onClick={() => { handleGo(`register-user`) }}>Usúarios   </LI>
                    <LI id="point"> </LI>
                    <LI isActive={'register-project' === routeActive} onClick={() => { handleGo(`register-project`) }}>Projetos   </LI>
                    <LI id="point">  </LI>
                    <LI><a href="https://estudiocriar.com/" target="black">Site Oficial </a>   </LI>
                </ul>

            </Menu>

            <BoxRight>
                <Welcome>{`Ola, ${credential.user.name} `}</Welcome>
                <Exit onClick={handleGetOut}>
                    <FiLogOut size={20} id="IconFacebook" /> 
                   Sair
                </Exit>
            </BoxRight>

        </Container>
    );
};

export default Preloader